<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="navBar">
      <img class="homeImg" src="../../assets/img/talk/icon_4_18.png" alt />
      <div @click="goTalk">校园论坛</div>
      <img class="arrow" src="../../assets/img/talk/icon_4_27.png" alt />
      <div v-if="name">{{ name }}</div>
    </div>
    <!-- 无 -->
    <div class="none" v-if="tieList.length == 0">
      <div>您暂时还没有发布过帖子哦</div>
      <div class="none_btn">去发布</div>
    </div>
    <!-- 帖子列表 -->
    <div class="tie_list">
      <div class="tie_item" v-for="(item1, index1) in tieList" :key="index1">
        <div class="tie_left">
          <img :src="headerImg ?imgUrl+ headerImg:'../../assets/img/home/img8.png'" alt />
          <div>{{userInfo.username}}</div>
        </div>
        <div class="tie_tight">
          <div class="tie_title">
            <div>{{item1.title}}</div>
            <div @click="del(item1.id)">
              <img src="../../assets/img/personal/icon_5_6.png" alt />
              删除
            </div>
          </div>
          <div class="tie_desc">{{item1.content}}</div>
          <div class="tie_img">
            <img v-for="(item2, index2) in item1.atlas" :key="index2" :src="imgUrl+item2" alt />
          </div>
          <div class="tie_btm">
            <div class="btm_left">
              来自 —
              <span>{{item1.from}}</span>
            </div>
            <div class="btm_right">
              <div class="btm_item">
                <img class="img1" src="../../assets/img/talk/icon_4_8.png" alt />
                <div>{{item1.collection}}</div>
              </div>
              <div class="btm_item">
                <img class="img2" src="../../assets/img/talk/icon_4_10.png" alt />
                <div>{{item1.comment}}</div>
              </div>
              <div class="btm_item">
                <img class="img3" src="../../assets/img/talk/icon_4_11.png" alt />
                <div>{{item1.praise}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "store";
import { myForum, delForum } from "../../assets/js/api.js";
export default {
  props: ["name"],
  data() {
    return {
      imgUrl: "http://education.hnzye.cn",
      tieList: [],
      userInfo: "",
      headerImg: "",
    };
  },
  mounted() {
    this.userInfo = store.get("info");
    this.headerImg = store.get("header_img");
    console.log(this.name);
    this.getMyForum();
  },
  methods: {
    getMyForum() {
      myForum().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.tieList = res.data.list;
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    del(id) {
      delForum(id).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.$message.success("已删除");
          let i = this.tieList.findIndex((item) => item.id == id);
          console.log(i)
           this.tieList.splice(i,1)
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    goTalk() {
      this.$emit("child-event", -1);
    },
  },
};
</script>

<style lang="less" scoped>
.navBar {
  width: 805px;
  // height: 50px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .homeImg {
    width: 16px;
    height: 15px;
    margin-right: 10px;
  }

  .arrow {
    width: 7px;
    height: 10px;
    margin: 0 10px;
  }

  div:nth-child(2) {
    color: #999999;
    cursor: pointer;
  }

  div:nth-child(4) {
    color: #029aff;
  }
}

.none {
  font-size: 18px;
  color: #0199ff;
  margin: 200px auto;
  text-align: center;

  .none_btn {
    width: 120px;
    height: 40px;
    background: #0199ff;
    border-radius: 10px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    margin-top: 40px;
    cursor: pointer;
  }
}

.tie_list {
  margin-bottom: 40px;

  .tie_item {
    padding: 25px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    margin-bottom: 10px;

    .tie_left {
      color: #333;
      font-size: 14px;
      text-align: center;
      margin-right: 20px;

      img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
      }
    }

    .tie_tight {
      width: 100%;

      .tie_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        div:nth-child(1) {
          font-size: 18px;
          color: #333;
        }

        div:nth-child(2) {
          font-size: 14px;
          color: #999;
          cursor: pointer;

          img {
            width: 15px;
            height: 17px;
            vertical-align: top;
          }
        }
      }

      .tie_desc {
        font-size: 14px;
        color: #656565;
        line-height: 2;
      }

      .tie_img {
        width: 380px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 20px 0;

        img {
          width: 120px;
          height: 120px;
          margin-bottom: 10px;
        }
      }

      .tie_btm {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btm_left {
          font-size: 16px;
          color: #333;

          span {
            color: #0199ff;
            cursor: pointer;
          }
        }

        .btm_right {
          display: flex;
          align-items: center;

          .btm_item {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #999;

            img {
              margin-right: 8px;
            }

            .img1 {
              width: 19px;
              height: 19px;
              cursor: pointer;
            }

            .img2 {
              width: 18px;
              height: 16px;
              cursor: pointer;
            }

            .img3 {
              width: 12px;
              height: 16px;
            }
          }

          .btm_item:nth-child(2) {
            margin: 0 30px;
          }
        }
      }
    }
  }
}
</style>
